const _formatNumberWithSpace = (n, decimals = 2) => {
  if (n === undefined || n === null || isNaN(Number(n))) return "--";
  const negative = Number(n) < 0;
  const abs = Math.abs(Number(n));
  const fixed = abs.toFixed(decimals);
  let [intPart, decPart] = fixed.split('.');
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return (negative ? '-' : '') + intPart + (decimals > 0 ? ',' + decPart : '');
};

export const formatMetricNumber = (n, decimals = 0) => _formatNumberWithSpace(n, decimals);
export const createMetricAmountFormater = (currency, localization) => (n) =>
  new Intl.NumberFormat(localization, {
    style: 'currency',
    currency: currency || "BRL",
    notation: "compact"
  }).format(n);

export const createAmountFormater = (currency, localization) => (n) =>
  new Intl.NumberFormat(localization, {
    style: 'currency',
    currency: currency || "BRL",
    
  }).format(n);

export const formatBRL = (n) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);